var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.691,
    height: 40.22,
    viewBox: "0 0 43.691 40.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-220 -383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(220 383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar-date-schedule-svgrepo-com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M52.632,9.067h-5.36l-.02,0V8.162a2.985,2.985,0,0,0-3.206-2.688,2.985,2.985,0,0,0-3.206,2.688v.9H34.8v-.9a2.985,2.985,0,0,0-3.206-2.688,2.985,2.985,0,0,0-3.206,2.688v.9H22.345v-.9a2.985,2.985,0,0,0-3.206-2.688,2.985,2.985,0,0,0-3.206,2.688v.9H10.565a.754.754,0,0,0-.812.68V45.014a.755.755,0,0,0,.812.68H52.632a.755.755,0,0,0,.812-.68V9.747A.755.755,0,0,0,52.632,9.067Zm-10.17-.9a1.608,1.608,0,0,1,3.166,0v3.755a1.608,1.608,0,0,1-3.166,0ZM31.592,6.835a1.474,1.474,0,0,1,1.583,1.327v3.755a1.608,1.608,0,0,1-3.166,0V9.811a.274.274,0,0,0,0-.128V8.162A1.474,1.474,0,0,1,31.592,6.835ZM17.555,8.162a1.474,1.474,0,0,1,1.583-1.327,1.474,1.474,0,0,1,1.583,1.327v3.755a1.474,1.474,0,0,1-1.583,1.327,1.474,1.474,0,0,1-1.583-1.327ZM51.82,44.334H11.376V10.427h4.556v1.49a2.985,2.985,0,0,0,3.206,2.688,2.985,2.985,0,0,0,3.206-2.688V10.428h6.041v1.489a2.985,2.985,0,0,0,3.206,2.688A2.985,2.985,0,0,0,34.8,11.917V10.428h6.04v1.489a2.985,2.985,0,0,0,3.206,2.688,2.985,2.985,0,0,0,3.206-2.688V10.426l.02,0H51.82Z",
    transform: "translate(-9.753 -5.474)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(225.588 396.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(12.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(2.015 2.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x2: 3.218,
    y2: 2.413
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x1: 3.218,
    y2: 2.413
  }))), /*#__PURE__*/React.createElement("path", {
    id: "box-outer-light-all-svgrepo-com",
    d: "M0,0H7.239V7.239H0V0M.658.658V6.581H6.581V.658Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(2.058 2.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M120.751,62.318a.33.33,0,0,0,.467,0l1.76-1.76a.33.33,0,1,0-.467-.467l-1.527,1.527-.427-.427a.33.33,0,1,0-.467.467Z",
    transform: "translate(-119.985 -59.985)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "box-outer-light-all-svgrepo-com-2",
    "data-name": "box-outer-light-all-svgrepo-com",
    d: "M0,0H7.239V7.239H0V0M.658.658V6.581H6.581V.658Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(25.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "box-outer-light-all-svgrepo-com-3",
    "data-name": "box-outer-light-all-svgrepo-com",
    d: "M0,0H7.239V7.239H0V0M.658.658V6.581H6.581V.658Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(2.071 2.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84-2",
    "data-name": "Path 84",
    d: "M120.751,62.318a.33.33,0,0,0,.467,0l1.76-1.76a.33.33,0,1,0-.467-.467l-1.527,1.527-.427-.427a.33.33,0,1,0-.467.467Z",
    transform: "translate(-119.985 -59.985)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(12.193 12.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14-2",
    "data-name": "Group 14",
    transform: "translate(2.143 2.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66-2",
    "data-name": "Group 66",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_17-2",
    "data-name": "Line 17",
    x2: 3.089,
    y2: 2.317,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18-2",
    "data-name": "Line 18",
    x1: 3.089,
    y2: 2.317,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "box-outer-light-all-svgrepo-com-4",
    "data-name": "box-outer-light-all-svgrepo-com",
    d: "M0,0H7.239V7.239H0V0M.658.658V6.581H6.581V.658Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(25.402 12.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "box-outer-light-all-svgrepo-com-5",
    "data-name": "box-outer-light-all-svgrepo-com",
    d: "M0,0H7.239V7.239H0V0M.658.658V6.581H6.581V.658Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(2.058 2.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84-3",
    "data-name": "Path 84",
    d: "M120.751,62.318a.33.33,0,0,0,.467,0l1.76-1.76a.33.33,0,1,0-.467-.467l-1.527,1.527-.427-.427a.33.33,0,1,0-.467.467Z",
    transform: "translate(-119.985 -59.985)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(0 12.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "box-outer-light-all-svgrepo-com-6",
    "data-name": "box-outer-light-all-svgrepo-com",
    d: "M0,0H7.239V7.239H0V0M.658.658V6.581H6.581V.658Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_84-4",
    "data-name": "Path 84",
    d: "M120.751,62.318a.33.33,0,0,0,.467,0l1.76-1.76a.33.33,0,1,0-.467-.467l-1.527,1.527-.427-.427a.33.33,0,1,0-.467.467Z",
    transform: "translate(-117.927 -57.445)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.0102ce8ac6258f4eb84ae9fba0398bfb.svg";
export { ForwardRef as ReactComponent };